<template>
  <div class="container-fluid">
    <page-header :page="page">
      <template #custom_actions>
        <div
          :class="{
            'd-flex justify-content-end h-100 align-items-end': isMobile,
          }"
        >
          <ActionButton
            text="Regresar"
            :class="['mr-3', { 'w-50': isMobile }]"
            variant="outline-success"
            i="fas fa-arrow-circle-left"
            @click="$router.go(-1)"
          />
          <ActionButton
            v-if="isEditMode"
            text="Eliminar"
            :class="['mr-3', { 'w-50': isMobile }]"
            variant="outline-danger"
            i="fas fa-times-circle"
            @click="deleteForm"
          />
          <ActionButton
            :class="{ 'w-50': isMobile }"
            text="Guardar"
            variant="success"
            i="fas fa-save"
            @click="saveForm"
          />
        </div>
      </template>
    </page-header>
    <div>
      <ValidationObserver ref="createEditForm">
        <div class="d-flex">
          <SectionTitle has-line content="Información de Formulario" />
        </div>
        <div class="row d-flex justify-content-start">
          <div class="col-12 col-md-5">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="form.number"
                label="Prefijo:"
                label-class="text-title"
                :error="errors[0]"
                :custom-error-msg="resources['FRM0001']"
              />
            </ValidationProvider>
          </div>
          <div :class="['col-12 col-md-5', { 'pt-3': isMobile }]">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="form.category"
                label="Categoría:"
                :regular-label="isMobile"
                :options="categories"
                fieldkey="id"
                fieldname="name"
                :error="errors[0]"
                :custom-error-msg="resources['FRM0002']"
              />
            </ValidationProvider>
          </div>
          <div
            v-if="isEditMode"
            :class="[
              'col-12 col-md-2',
              { 'mt-4': !isMobile, 'py-3': isMobile },
            ]"
          >
            <div class="mt-2">
              <div
                class="custom-control custom-checkbox custom-whitebg-checkbox"
                style="margin-top:10px"
              >
                <input
                  id="chkActive"
                  v-model="form.isActive"
                  type="checkbox"
                  name="chkActive"
                  class="custom-control-input"
                />
                <label for="chkActive" class="custom-control-label font bold">
                  <span><em class="ic-check" /></span>
                  Activo
                </label>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="['row d-flex justify-content-start', { 'pt-3': !isMobile }]"
        >
          <div class="col-12 col-md-12">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="form.title"
                label="Título:"
                label-class="text-title"
                :error="errors[0]"
                maxlength="100"
                :custom-error-msg="resources['FRM0006']"
              />
            </ValidationProvider>
          </div>
        </div>
        <div
          :class="['row d-flex justify-content-start', { 'pt-3': !isMobile }]"
        >
          <div :class="['col-12 col-md-12', { 'pt-3': isMobile }]">
            <label>Descripción:</label>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <CustomTextArea
                v-model="form.description"
                style="width:100%"
                :maxlength="2000"
                :classes="['eq-field', 'text-left']"
                :regular-label="isMobile"
                :rows="3"
                :error="errors[0]"
                :custom-error-msg="resources['FRM0003']"
              />
            </ValidationProvider>
          </div>
        </div>

        <custom-callout
          :has-toggle="false"
          border-color="gray"
          :class="['mt-2 pt-3']"
        >
          <div :class="['row', { 'p-2': !isMobile }]">
            <div class="col-12 pl-2">
              <div class="row">
                <div
                  :class="['col-12 col-md-8 pt-0', { 'ml-3 pt-3': isMobile }]"
                >
                  <div :class="{ 'divider-horizontal': !isMobile }">
                    <div class="row">
                      <span v-show="!isMobile" class="callout">Documento:</span>
                      <ValidationProvider v-slot="{ errors }" rules="required">
                        <CustomFileInput
                          v-if="
                            (form.attachmentName && isEditMode) || !isEditMode
                          "
                          ref="attachedDocument"
                          v-model="form.document"
                          :accept="'.pdf'"
                          :attachment-id="form.attachmentId || form.documentId"
                          :name="form.attachmentName"
                          required
                          display-style="normal"
                          label-position="left"
                          :error="errors[0]"
                          :custom-error-msg="resources['FRM0005']"
                          :on-download="downloadForm"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div
                  :class="['col-12 col-md-4 pt-0', { 'pt-3 px-4': isMobile }]"
                >
                  <div class="row">
                    <div class="col-12 pt-0">
                      <div :class="['row']">
                        <div :class="['callout', { 'w-100': isMobile }]">
                          Expira:
                        </div>
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="FechaFirma"
                          rules="required"
                        >
                          <CustomDatePicker
                            v-model="form.expireDate"
                            :class="{ 'pl-2 pb-2': isMobile }"
                            required
                            format="dd/MM/yyyy"
                            :error="errors[0]"
                            placeholder="DD/MM/YYYY"
                            :min-date="futureDate"
                            :custom-error-msg="resources['FRM0004']"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </custom-callout>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/common/page/PageHeader';
import ActionButton from '@/components/common/ActionButton';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { SectionTitle } from '@/components/pei/shared';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import formManagementApi from '@/modules/operation-form-management/api.js';
import CustomTextArea from 'CustomTextArea';
import CustomDatePicker from 'custom-date-picker';
import CustomCallout from 'custom-callout';
import CustomFileInput from 'CustomFileInput';
import resourcesService from '@/services/resources.js';
import mixWait from '@/mixin/loading.mixin';
import alert from '@/mixin/alert.mixin';
import documentsService from '@/services/documents';
import moment from 'moment';

export default {
  name: 'CreateEditForm',
  mixins: [mixWait, alert],
  components: {
    PageHeader,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
    SectionTitle,
    CustomInput,
    CustomDropDown,
    CustomTextArea,
    CustomDatePicker,
    CustomCallout,
    CustomFileInput,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-calculator',
        title: 'Manejo de Formularios',
        routes: [
          'Inicio',
          'Operaciones',
          'Manejo de Formularios',
          'Crear Formulario',
        ],
      },
      form: {},
      categories: [],
      allowedFiles: '.pdf',
      resources: [],
    };
  },
  methods: {
    async saveForm() {
      const isValid = await this.$refs.createEditForm.validate();
      if (isValid) {
        if (this.form.isActive && moment(this.form.expireDate).isBefore()) {
          this.ShowToast('Alerta', this.resources['FRM0007'], 'error');
          return;
        }
        let formData = new FormData();
        formData.append('number', this.form.number);
        formData.append('categoryCode', this.form.category.id);
        formData.append(
          'isActive',
          this.isEditMode ? this.form.isActive : true
        );
        formData.append('title', this.form.title);
        formData.append('description', this.form.description);
        formData.append('document', this.form.document);
        formData.append(
          'expireDate',
          moment(this.form.expireDate).format('MM/DD/YYYY')
        );

        if (this.isEditMode) {
          formData.append('id', this.$route.params.id);
          await formManagementApi
            .update(formData)
            .then((res) => {
              if (res.status == 200) {
                this.ShowToast(
                  'Proceso exitoso.',
                  'Sus datos han sido guardados exitosamente.',
                  'success'
                );
                this.$router.go(-1);
              }
            })
            .catch((err) => {
              if (err && err.response && err.response.data) {
                this.ShowToast('Error', err.response.data.message, 'error');
              } else {
                this.ShowToast('Error', err.message, 'error');
              }
            });
        } else {
          await formManagementApi
            .create(formData)
            .then((res) => {
              if (res.status == 200) {
                this.ShowToast(
                  'Proceso exitoso.',
                  'Sus datos han sido guardados exitosamente.',
                  'success'
                );
                this.$router.go(-1);
              }
            })
            .catch((err) => {
              if (err && err.response && err.response.data) {
                this.ShowToast('Error', err.response.data.message, 'error');
              } else {
                this.ShowToast('Error', err.message, 'error');
              }
            });
        }
      } else {
        this.ShowToast(
          'Alerta',
          'Favor de ingresar la información solicitada para continuar \
                  con la creación de nuevo Formulario.',
          'error'
        );
      }
    },
    async getCategories() {
      await formManagementApi.getCategories().then((res) => {
        const data = res.data ? res.data : [];
        this.categories = data.sort((a, b) => a.name.localeCompare(b.name));
      });
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'FRM0001',
        'FRM0002',
        'FRM0003',
        'FRM0004',
        'FRM0005',
        'FRM0006',
        'FRM0007',
      ]);
    },
    async getFormData() {
      if (this.isEditMode) {
        const id = this.$route.params.id;

        await formManagementApi.getFormData(id).then((res) => {
          this.form = res.data;
          this.form.document = new File(
            [this.form.documentContent],
            this.form.attachmentName
          );
        });
      }
    },
    downloadForm: function() {
      formManagementApi
        .downloadForm(this.form)
        .then((response) => {
          documentsService.Download(response.data);
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    async deleteForm() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea eliminar el formulario ${this.form.title}?`
      );
      if (answer) {
        formManagementApi
          .deleteForm(this.$route.params.id)
          .then(() => {
            this.ShowToast(
              ' Proceso Exitoso',
              'El fomulario ha sido removido exitosamente.',
              'success'
            );
            this.$router.go(-1);
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              this.ShowToast('Error', err.response.data.message, 'error');
            } else {
              this.ShowToast('Error', err.message, 'error');
            }
          });
      }
    },
  },
  async mounted() {
    await this.getCategories();
    await this.loadResources();
    await this.getFormData();
  },
  computed: {
    futureDate() {
      const today = new Date();
      today.setDate(new Date().getDate());

      return today;
    },
    isEditMode() {
      return this.$route.params.id ? true : false;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
};
</script>

<style scoped>
.divider-horizontal {
  border-right: 1px solid #e2e2e2;
  height: 100%;
}

.callout {
  color: #727272;
  font-size: 14px;
  font-weight: 400;
  margin: 10px 10px;
}

.custom-control-label {
  color: #727272 !important;
}

label {
  color: #727272 !important;
}

@media only screen and (max-width: 375px) {
  ::v-depp .text-title {
    font-size: 12px !important;
    font-weight: normal !important;
  }

  ::v-depp .regular {
    font-size: 12px !important;
  }

  .custom-control-label {
    font-size: 12px !important;
    font-weight: normal !important;
    line-height: 24px;
  }

  ::v-depp .file-input-container {
    padding: 15px;
    width: 115% !important;
  }

  ::v-depp .font-weight-bold {
    font-size: 12px !important;
    font-weight: normal !important;
  }

  .custom-date > .input-group > .form-control {
    font-size: 12px !important;
  }

  label {
    font-size: 12px !important;
    font-weight: normal !important;
  }

  ::v-depp.tag-badge-title-info {
    font-size: 12px !important;
  }

  .callout {
    font-size: 12px !important;
  }

  ::v-depp label {
    font-size: 12px !important;
  }
}
</style>
